import { CafsType } from "../../../consts/cafsType";
import { VariableRenderProps } from "../../../types/variable-render-props";

export function renderForCrop({ cafsType }: VariableRenderProps) {
  return cafsType === CafsType.Crop;
}
